import { render, staticRenderFns } from "./PlatformsIndex.vue?vue&type=template&id=330b5eb0&"
import script from "./PlatformsIndex.vue?vue&type=script&lang=ts&"
export * from "./PlatformsIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports